import React from 'react'
import { Checkbox, type CheckboxProps } from '@mantine/core'

export type AppCheckboxProps = CheckboxProps

export default function AppCheckbox (props: AppCheckboxProps) {
  return <Checkbox radius="sm" {...props} />
}
